import { Button, Text } from "@ttc3k/trekker";
import { Address } from "gql/generated";
import { HomeAlt, OpenNewWindow } from "iconoir-react";
import { useTranslation } from "react-i18next";
import { StaticMap } from "shared/components";
import { createGoogleMapsUrl, getAddressString } from "shared/utils";
import { Flex } from "styled-system/jsx";
import { ReservationSection } from "./ReservationSection";

type GettingHereProps = {
  address: Address;
};

export const GettingHere = ({ address }: GettingHereProps) => {
  const { t } = useTranslation("storefront", {
    keyPrefix: "RESERVATION_DETAILS.GETTING_HERE",
  });

  if (
    !address ||
    !address.location ||
    !address.location.coordinates ||
    address.location.coordinates.length === 0
  ) {
    return null;
  }

  const handleOpenClick = () => {
    const url = createGoogleMapsUrl(address);
    window.open(url, "_blank");
  };

  return (
    <ReservationSection icon={HomeAlt} title={t("TITLE")}>
      <Flex
        alignItems="center"
        justifyContent="space-between"
        gap="200"
        border="2px solid"
        borderColor="border.light"
        borderRadius="100"
        p="300"
      >
        <Text visual="bodyMedium" color="text.mid">
          {getAddressString(address, false, false)}
        </Text>
        <Button
          visual="primary"
          mode="light"
          size="sm"
          Icon={OpenNewWindow}
          isIconRightAligned={true}
          flexShrink={0}
          onClick={handleOpenClick}
        >
          {t("GOOGLE_MAPS")}
        </Button>
      </Flex>
      <StaticMap
        locations={[
          {
            latitude: address.location.coordinates[1] ?? 0,
            longitude: address.location.coordinates[0] ?? 0,
          },
        ]}
      />
    </ReservationSection>
  );
};
